import { render, staticRenderFns } from "./ServiceOnline.vue?vue&type=template&id=f59de960&scoped=true"
import script from "./ServiceOnline.vue?vue&type=script&lang=js"
export * from "./ServiceOnline.vue?vue&type=script&lang=js"
import style0 from "./ServiceOnline.vue?vue&type=style&index=0&id=f59de960&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59de960",
  null
  
)

export default component.exports